import { Injectable } from '@angular/core';
import { initialize, LDClient, LDFlagSet } from 'launchdarkly-js-client-sdk';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BnplFeatureFlagService {
  ldClient!: LDClient
  flags!: LDFlagSet;
  thisCallback: any = null;

  constructor() {
    this.flags = { 'bnpl': false };
  }
  /**
   * @description {initFlags} Function to init the lauchDarkly service with anonymous session
  */
  initFlags(): Observable<any> {
    return new Observable((observer) => {
      try {
        this.ldClient = initialize(environment.ld_bnpl_group, { anonymous: true });
        this.ldClient.on('ready', () => {

          this.setFlags();
          observer.next();
          if (this.thisCallback != null) {
            this.thisCallback();
          }
        });
        this.ldClient.on('change', () => {
          this.setFlags();
          observer.next();
          if (this.thisCallback != null) {
            this.thisCallback();
          }
        });
      } catch (error) {
        observer.error(error);
      }
    });
  }
  /**
   * @description {setFlags} Function to sets all the keys disposed by launch Darkly proyect
  */
  setFlags() {
    this.flags = this.ldClient.allFlags();
  }
  /**
   * @description {setFlags} Function to this functions query in LaunchDarkly if exist the key
   * @param featureFlag The name of the flag to query his value
   * @returns if the flag exist return the value of the flag else return null;
  */
  getFlagValue(featureFlag: string) {
    if (this.flags.hasOwnProperty(featureFlag)) {
      return this.flags[featureFlag];
    }
    return null;
  }
}
